import { Source } from '../../types/chat';
import { resolvePillByCitationIndex } from '../../utils/source-citations';

interface CitationMarkerProps {
  /** Injected by react-markdown; carries `properties.dataRefIndex`. */
  node?: { properties?: { dataRefIndex?: string } };
  sources: Source[];
  onCitationClick: (index: number) => void;
}

/**
 * Inline superscript `[n]` for an `[[ref:n]]` token. Clickable when it resolves
 * to a pill; renders as plain (non-interactive) `[n]` otherwise.
 */
export const CitationMarker = ({ node, sources, onCitationClick }: CitationMarkerProps) => {
  const index = Number(node?.properties?.dataRefIndex);
  if (!Number.isFinite(index)) return null;

  const source = resolvePillByCitationIndex(sources, index);
  if (!source) {
    return <sup className="text-[0.7em] text-muted-foreground">[{index}]</sup>;
  }

  return (
    <sup className="text-[0.7em] leading-none">
      <button
        type="button"
        onClick={() => onCitationClick(index)}
        aria-label={`Source ${index}`}
        title={source.fileName}
        className="mx-[1px] inline-flex items-center justify-center rounded-[4px] bg-primary/10 px-1 font-medium text-primary hover:bg-primary/20 cursor-pointer"
      >
        {index}
      </button>
    </sup>
  );
};
